import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { EquipmentRestConnectorService, EquipmentService } from 'app/equipment/services';
import { EquipmentEffects } from 'app/equipment/state/equipment-effects';
import { equipmentReducer } from 'app/equipment/state/equipment.reducer';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';
import { DropzoneModule } from 'ngx-dropzone-wrapper';

import { EquipmentConfigurationCategoryDialogComponent } from './components/equipment-configuration-category-dialog/equipment-configuration-category-dialog.component';
import { EquipmentConfigurationItemDialogComponent } from './components/equipment-configuration-item-dialog/equipment-configuration-item-dialog.component';
import { EquipmentConfigurationItemComponent } from './components/equipment-configuration-item/equipment-configuration-item.component';
import { EquipmentDialogComponent } from './components/equipment-dialog/equipment-dialog.component';
import { UserDetailsEquipmentComponent } from './components/user-details-equipment/user-details-equipment.component';
import { WorkflowsViewComponent } from './components/workflows-view/workflows-view.component';

@NgModule({
  imports: [
    StoreModule.forFeature('equipment', equipmentReducer),
    EffectsModule.forFeature([
      EquipmentEffects,
    ]),
    CommonModule,
    SharedModule,
    MaterialModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DropzoneModule,
  ],
  providers: [
    EquipmentService,
    EquipmentRestConnectorService,
    EquipmentEffects,
  ],
  declarations: [
    UserDetailsEquipmentComponent,
    EquipmentDialogComponent,
    EquipmentConfigurationItemComponent,
    EquipmentConfigurationCategoryDialogComponent,
    EquipmentConfigurationItemDialogComponent,
    WorkflowsViewComponent,
  ],
  exports: [
    UserDetailsEquipmentComponent,
    EquipmentConfigurationItemComponent,
    EquipmentConfigurationItemDialogComponent,
    WorkflowsViewComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class EquipmentModule { }
